import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import MergeBaseMappingForm from './MergeBaseMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';

function MergeBaseCredentialsForm(props, ref) {
    const fields = [
    {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    }, {
        name: "apiToken",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD,
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={MergeBaseMappingForm}
        />
    )
}

export default forwardRef(MergeBaseCredentialsForm);